import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { SummaryService } from 'src/app/services/summary.service';

@Component({
  selector: 'app-annual-compare',
  templateUrl: './annual-compare.component.html',
  styleUrls: ['./annual-compare.component.scss'],
  standalone: false
})


export class AnnualCompareComponent implements OnInit {
  tableDataSource = new MatTableDataSource<any>();
  tableDataSourceBiggest = new MatTableDataSource<any>();
  displayedColumns!: string[];
  displayedColumnsBiggest!: string[];

  currentYear = new Date().getFullYear();
  currentDate = new Date();
  year10 = this.currentYear - 11;
  year5 = this.currentYear - 6;

  constructor(
    private readonly titleService: Title,
    private readonly summaryService: SummaryService,
  ) {
    this.titleService.setTitle("BAER - Annual Comparison")
  }


  ngOnInit(): void {
    this.loadData();

    this.displayedColumns = [
      'region',
      'currentFires',
      'currentAcres',
      'avg10Fires',
      'avg10Acres',
      'avg5Fires',
      'avg5Acres'
    ];
    this.displayedColumnsBiggest = [
      'region',
      'year',
      'fires',
      'acres'
    ];
  }

  loadData() {
    this.summaryService.getAnnualSummary().subscribe((data: any) => {
      let tableData: any[] = [];
      let tableDataBiggest: any[] = [];

      let currentYearData = data.filter((record: any) => record.year == this.currentYear);
      let Year10Data = data.filter((record: any) => record.year == 10);
      let Year5Data = data.filter((record: any) => record.year == 5);

      const regions = ['01', '02', '03', '04', '05', '06', '08', '09', '10', 'WO']

      for (const region of regions) {
        let selectedRegion = region;
        if (region == 'WO') selectedRegion = 'National';
        
        // setup first table
        const element = {
          'region': selectedRegion,
          'currentFires': currentYearData.find((record: any) => record.region == region)?.fire_count ?? 0,
          'currentAcres': currentYearData.find((record: any) => record.region == region)?.acres ?? 0,
          'avg10Fires': Year10Data.find((record: any) => record.region == region)?.fire_count,
          'avg10Acres': Year10Data.find((record: any) => record.region == region)?.acres,
          'avg5Fires': Year5Data.find((record: any) => record.region == region)?.fire_count,
          'avg5Acres': Year5Data.find((record: any) => record.region == region)?.acres
        };
        tableData.push(element);

        // setup second table
        const regionData = data.filter((record: any) => record.region == region);
        const largestAcres = regionData.reduce((max: any, obj: any) => (obj.acres > max.acres ? obj : max), regionData[0]);
        const elementBiggest = {
          'region': selectedRegion,
          'year': largestAcres.year,
          'fires': largestAcres.fire_count,
          'acres': largestAcres.acres
        }
        tableDataBiggest.push(elementBiggest);

        // create largest fires record
        if (region == 'WO') {
          const largestFires = regionData.reduce((max: any, obj: any) => (obj.fire_count > max.fire_count ? obj : max), regionData[0]);
          const elementBiggest = {
            'region': 'Largest Years',
            'year': largestFires.year,
            'fires': largestFires.fire_count,
            'acres': largestFires.acres
          }
          tableDataBiggest.push(elementBiggest);
        }
      };
      this.tableDataSource.data = tableData;
      this.tableDataSourceBiggest.data = tableDataBiggest;
    })
  }
}
